import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Mail, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0D2847] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* About */}
          <div className="col-span-1">
            <img 
              src="https://customer-assets.emergentagent.com/job_complete-web-dev-1/artifacts/klt0ggnd_Rudra%20Logo.png" 
              alt="Rudra Essence - Premium Wellness Solutions UAE" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-white/70 text-sm">
              Modern wellness solutions backed by science. Representing premium brands in molecular hydrogen, skincare, and infrared therapy.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-white/70 hover:text-white text-sm">About Us</Link></li>
              <li><Link to="/blog" className="text-white/70 hover:text-white text-sm">Blog</Link></li>
              <li><Link to="/faq" className="text-white/70 hover:text-white text-sm">FAQ</Link></li>
              <li><Link to="/contact" className="text-white/70 hover:text-white text-sm">Contact</Link></li>
              <li><Link to="/privacy" className="text-white/70 hover:text-white text-sm">Privacy Policy</Link></li>
            </ul>
          </div>

          {/* Our Brands */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Our Brands</h3>
            <ul className="space-y-2">
              <li><Link to="/molecular-hydrogen" className="text-white/70 hover:text-white text-sm">Axiom H2</Link></li>
              <li><Link to="/skincare" className="text-white/70 hover:text-white text-sm">Beauté Pacifique</Link></li>
              <li><Link to="/infrared-therapy" className="text-white/70 hover:text-white text-sm">Therasage</Link></li>
            </ul>
          </div>

          {/* Contact & Social */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Connect With Us</h3>
            <div className="space-y-3 mb-6">
              <a href="https://wa.me/971567295491" target="_blank" rel="noopener noreferrer" className="flex items-center text-white/70 hover:text-white text-sm">
                <Phone size={16} className="mr-2" />
                +971-56-7295491
              </a>
              <a href="mailto:info@rudraessence.com" className="flex items-center text-white/70 hover:text-white text-sm">
                <Mail size={16} className="mr-2" />
                info@rudraessence.com
              </a>
            </div>

            {/* Rudra Essence Social - For All Brands */}
            <div className="mb-4">
              <p className="text-xs text-white/50 mb-2 uppercase tracking-wider">Rudra Essence (All Brands)</p>
              <div className="flex space-x-3">
                <a 
                  href="https://instagram.com/RudraEssence.me" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="flex items-center justify-center w-9 h-9 bg-white/10 rounded-lg hover:bg-white/20 transition-colors"
                  aria-label="Rudra Essence Instagram"
                >
                  <Instagram size={18} />
                </a>
                <a 
                  href="https://www.facebook.com/profile.php?id=61576920195680" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="flex items-center justify-center w-9 h-9 bg-white/10 rounded-lg hover:bg-white/20 transition-colors"
                  aria-label="Rudra Essence Facebook"
                >
                  <Facebook size={18} />
                </a>
              </div>
            </div>

            {/* Beauté Pacifique Middle East Social */}
            <div>
              <p className="text-xs text-white/50 mb-2 uppercase tracking-wider">Beauté Pacifique Middle East</p>
              <div className="flex space-x-3">
                <a 
                  href="https://instagram.com/beautepacifique_me" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="flex items-center justify-center w-9 h-9 bg-gradient-to-br from-pink-500/20 to-purple-500/20 rounded-lg hover:from-pink-500/30 hover:to-purple-500/30 transition-colors"
                  aria-label="Beauté Pacifique Middle East Instagram"
                >
                  <Instagram size={18} />
                </a>
                <a 
                  href="https://www.facebook.com/profile.php?id=61567146166462" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="flex items-center justify-center w-9 h-9 bg-gradient-to-br from-pink-500/20 to-purple-500/20 rounded-lg hover:from-pink-500/30 hover:to-purple-500/30 transition-colors"
                  aria-label="Beauté Pacifique Middle East Facebook"
                >
                  <Facebook size={18} />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-8 pt-8 text-center text-white/60 text-sm">
          <p>&copy; {new Date().getFullYear()} Rudra Essence. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
